import React from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'react-intersection-observer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiPhone,FiExternalLink,FiHeart,FiFacebook,FiLinkedin,FiInstagram,FiMessageCircle}=FiIcons;

const Footer=()=> {
const [ref,inView]=useInView({triggerOnce: true,threshold: 0.1});
const currentYear=new Date().getFullYear();

const socialLinks=[ 
{name: 'LinkedIn',href: 'https://www.linkedin.com/in/sanna-darwish-m-s-ccc-slp-b2a3491a8',icon: FiLinkedin},
{name: 'Facebook',href: 'https://Facebook.com/337098602826472',icon: FiFacebook},
{name: 'Instagram',href: 'https://www.instagram.com/wethebillions',icon: FiInstagram},
{name: 'WhatsApp',href: 'https://wa.me/+12026560054',icon: FiMessageCircle} 
];

const legalLinks=[ 
{name: 'Terms of Service',href: '/terms'},
{name: 'Privacy Policy',href: '/privacy'},
{name: 'Accessibility',href: '/accessibility'} 
];

return ( 
<footer className="bg-gray-900 text-white" ref={ref}> 
<div className="max-w-7xl mx-auto px-6 lg:px-8 py-20"> 
<div className="grid lg:grid-cols-4 gap-16"> 
{/* Brand Section */} 
<motion.div initial={{opacity: 0,y: 20}} animate={inView ? {opacity: 1,y: 0} : {}} transition={{duration: 0.8}} className="lg:col-span-2 space-y-8" > 
<div className="flex items-center space-x-4"> 
<img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753416293845-4.png" alt="We The Billions Brain Icon" className="h-16 w-16" /> 
<div> 
<h3 className="text-3xl font-bold font-serif">We The Billions</h3> 
<p className="text-gray-400 text-lg">86 billion neurons. 1 unique YOU.</p> 
</div> 
</div> 

<p className="text-gray-300 leading-relaxed text-lg max-w-md"> Specialized early intervention therapy for communication,feeding,and executive function development. Building foundations that last a lifetime. </p> 

<div className="bg-gradient-to-r from-accent-magenta/20 to-accent-purple/20 p-6 rounded-xl"> 
<p className="text-white font-semibold text-lg mb-2">Virtual Sessions (Globally) & In-Person Sessions (MD & VA)</p> 
<p className="text-gray-300 flex items-center"> Made with <SafeIcon icon={FiHeart} className="h-5 w-5 text-red-400 mx-2" /> for every unique brain </p> 
</div> 

<div className="space-y-4"> 
<div className="flex items-center space-x-4"> 
<SafeIcon icon={FiMail} className="h-6 w-6 text-accent-magenta" /> 
<a href="mailto:hello@wethebillions.com" className="text-gray-300 hover:text-white transition-colors text-lg" > hello@wethebillions.com </a> 
</div> 

<div className="flex items-center space-x-4"> 
<SafeIcon icon={FiPhone} className="h-6 w-6 text-accent-magenta" /> 
<a href="tel:+12026560054" className="text-gray-300 hover:text-white transition-colors text-lg" > (202) 656-0054 </a> 
</div> 

<div className="flex items-center space-x-4"> 
<SafeIcon icon={FiExternalLink} className="h-6 w-6 text-accent-magenta" /> 
<a href="https://www.wethebillions.com" className="text-gray-300 hover:text-white transition-colors text-lg" > www.wethebillions.com </a> 
</div> 
</div> 
</motion.div> 

{/* Quick Links */} 
<motion.div initial={{opacity: 0,y: 20}} animate={inView ? {opacity: 1,y: 0} : {}} transition={{duration: 0.8,delay: 0.1}} className="space-y-8" > 
<h4 className="text-2xl font-semibold font-serif">Quick Links</h4> 
<ul className="space-y-4"> 
<li> 
<button onClick={()=> document.getElementById('about')?.scrollIntoView({behavior: 'smooth'})} className="text-gray-300 hover:text-white transition-colors text-lg" > About Sanna </button> 
</li> 
<li> 
<button onClick={()=> document.getElementById('how-it-works')?.scrollIntoView({behavior: 'smooth'})} className="text-gray-300 hover:text-white transition-colors text-lg" > How It Works </button> 
</li> 
<li> 
<button onClick={()=> document.getElementById('results')?.scrollIntoView({behavior: 'smooth'})} className="text-gray-300 hover:text-white transition-colors text-lg" > Results </button> 
</li> 
<li> 
<button onClick={()=> document.getElementById('faq')?.scrollIntoView({behavior: 'smooth'})} className="text-gray-300 hover:text-white transition-colors text-lg" > FAQ </button> 
</li> 
<li> 
<a href="https://www.wethebillions.com/quiz" className="text-gray-300 hover:text-white transition-colors text-lg" > Assessment Quiz </a> 
</li> 
</ul> 
</motion.div> 

{/* Social & Legal */} 
<motion.div initial={{opacity: 0,y: 20}} animate={inView ? {opacity: 1,y: 0} : {}} transition={{duration: 0.8,delay: 0.2}} className="space-y-8" > 
<h4 className="text-2xl font-semibold font-serif">Follow Us On</h4> 
<div className="flex space-x-4"> 
{socialLinks.map((social)=> ( 
<a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-accent-magenta transition-colors duration-200" aria-label={social.name} > 
<SafeIcon icon={social.icon} className="h-6 w-6 text-white" /> 
</a> 
))} 
</div> 

<div className="space-y-4"> 
{legalLinks.map((link)=> ( 
<div key={link.name}> 
<a href={link.href} className="text-gray-300 hover:text-white transition-colors text-lg" > {link.name} </a> 
</div> 
))} 
</div> 
</motion.div> 
</div> 

{/* Bottom Bar */} 
<motion.div initial={{opacity: 0}} animate={inView ? {opacity: 1} : {}} transition={{duration: 0.8,delay: 0.3}} className="border-t border-gray-800 mt-16 pt-12 text-center" > 
<p className="text-gray-400 text-lg"> © {currentYear} We The Billions. All rights reserved. | Specialized Early Intervention Therapy </p> 
<p className="text-gray-500 mt-2"> Licensed Speech-Language Pathology Services | M.S. CCC-SLP </p> 
</motion.div> 
</div> 
</footer> 
);
};

export default Footer;